import React from 'react'
import {RadioButton} from '@components/common/base/radiobutton'

export interface RadiobuttonProps {
  error?: boolean
  footnote?: string
  label?: string
  active: boolean
  disabled?: boolean
  onClick: () => void
  className?: string
}

export const SharedRadioButton = ({
  active,
  onClick,
  label,
  footnote,
  disabled,
  error,
  className
}: RadiobuttonProps) => (
  <RadioButton
    active={active}
    onClick={onClick}
    label={label}
    footnote={footnote}
    disabled={disabled}
    error={error}
    className={className}
  />
)
